import { useMutation } from "@apollo/client";
import { Card, Icon } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import curved9 from "assets/images/curved-images/curved0.jpg";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useState } from "react";
import routes from "routes";
import { login } from "services/login";
import ModalCambiarPass from "../ModalCambiarPass";
import ModalActualizarPassword from "../actualizar-password";
import BasicLayout from "../components/BasicLayout";
import CrearCuenta from "../components/CrearCuentaProveedor";
import FormularioRegistro from './formularioRegistro'
function Proveedores() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);
  const [errorLogin, setErrorLogin] = useState(null);
  const [openCambiarPass, setOpenCambiarPass] = useState(false);
  const [cambioPendiente, setCambioPendiente] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const [loginUser, { data, loading, error }] = useMutation(login);

  const handleChanges = (event) => {
    const { name, value } = event.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const finalizarLogin = (loginData) => {
    const history = JSON.parse(localStorage.getItem("history"));

    if (loginData?.user?.tempPassword) {
      setOpenCambiarPass(true);
      return;
    }

    let rutasPrivadas = routes.filter((route) => route.permiso);
    let rutasPermitidas = rutasPrivadas.filter((route) =>
      loginData?.user?.permisos?.find((item) => item.pantalla === route.permiso)
    );
    localStorage.setItem(
      "user",
      JSON.stringify({ token: loginData?.token })
    );
    localStorage.removeItem("history");
    if (history && history.includes("/nodos/")) {
      window.location.href = history;
      return;
    }
    if (loginData?.user?.id === "1") {
      window.location.href = "/productos";
      return;
    }
    if (rutasPermitidas.length > 0) {
      window.location.href = rutasPermitidas[0].route;
      return;
    } else {
      window.location.href = "/soporte";
      return;
    }
  };

  const handleLogin = (event) => {
    event.preventDefault();
    setErrorLogin(null);
    if (username !== "" && password !== "") {
      setEmptyFields(false);
      loginUser({
        variables: {
          userInput: {
            username: username,
            passwordPlain: password,
          },
        },
      })
        .then((result) => {
          if (result.data.login !== null) {
            const loginData = result?.data?.login;

            if (loginData?.requiereCambioPassword) {
              setCambioPendiente({
                cambioToken: loginData.cambioToken,
                emailEnmascarado: loginData.emailEnmascarado,
              });
              return;
            }

            finalizarLogin(loginData);
          }
        })
        .catch((error) => {
          console.error("Error al iniciar sesión:", error);
          if (error.message === "Failed to fetch")
            setErrorLogin("No se pudo conectar con el servidor");
          else setErrorLogin(error.networkError.result.errors[0].message);
        });
    } else {
      setEmptyFields(true);
    }
  };

  return (
    <BasicLayout
      title={isCreating ? "Crear cuenta" : "Iniciar sesión"}
      description={
        isCreating
          ? "Crea una cuenta de proveedor para participar en las licitaciones"
          : "Ingrese su usuario y contraseña para iniciar sesión como proveedor"
      }
      image={curved9}
      size={isCreating ? "large" : "regular"}
    >
      <Card>
        {isCreating ? (
          <FormularioRegistro handleCancel={() => setIsCreating(false)} />
        ) : (
          <SoftBox component="form" role="form" p={3}>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Usuario
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                placeholder="Usuario"
                name="username"
                value={username}
                onChange={handleChanges}
                error={data && data.authenticateUser === null}
                autoComplete="username"
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Contraseña
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="password"
                placeholder="Contraseña"
                name="password"
                value={password}
                onChange={handleChanges}
                error={data && data.authenticateUser === null}
                autoComplete="current-password"
              />
            </SoftBox>
            <SoftBox mt={4} mb={1}>
              <SoftBox>
                <SoftButton type="submit" color="primary" fullWidth circular onClick={handleLogin}>
                  {loading ? <CircularProgress color="inherit" size={17} /> : "Iniciar sesión"}
                </SoftButton>
              </SoftBox>
              <SoftBox mt={2}>
                <SoftButton
                  type="submit"
                  color="uproGreen"
                  fullWidth
                  circular
                  onClick={() => setIsCreating(true)}
                >
                  Crear cuenta &nbsp;
                  <Icon sx={{ fontWeight: "light" }}>arrow_forward</Icon>
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <SoftBox
              mt={emptyFields || error || errorLogin ? 2 : 0}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              {emptyFields && (
                <SoftTypography variant="caption" color="error">
                  Debes ingresar un usuario y contraseña
                </SoftTypography>
              )}
              {!emptyFields && error && (
                <SoftTypography variant="caption" color="error">
                  {errorLogin}
                </SoftTypography>
              )}
              {!emptyFields && errorLogin && error === undefined && (
                <SoftTypography variant="caption" color="error">
                  {errorLogin}
                </SoftTypography>
              )}
            </SoftBox>
          </SoftBox>
        )}
      </Card>
      <ModalCambiarPass
        open={openCambiarPass}
        handleClose={() => setOpenCambiarPass(false)}
        data={data}
      />
      <ModalActualizarPassword
        open={Boolean(cambioPendiente)}
        cambioToken={cambioPendiente?.cambioToken}
        emailEnmascarado={cambioPendiente?.emailEnmascarado}
        onCancel={() => setCambioPendiente(null)}
        onSuccess={(loginData) => {
          setCambioPendiente(null);
          finalizarLogin(loginData);
        }}
      />
    </BasicLayout>
  );
}

export default Proveedores;
